const REGEX = /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})+$/;

export const isDomainValid = (domain: string) => REGEX.test(domain);
